import React, { FunctionComponent } from 'react';
import { CheckListProps } from 'components/check-list/check-list';
import JoinHivesDesktop from './join-hives-desktop';
import JoinHivesMobile from './join-hives-mobile';

export type JoinHivesProps = {
    title: string;
    text: string;
    bullets: CheckListProps['items'];
    cta: {
        text: string;
        url?: string;
    };
    appStore: {
        url: string;
        text: string;
    };
    playStore: {
        url: string;
        text: string;
    };
    isMobile?: boolean;
};

const JoinHives: FunctionComponent<JoinHivesProps> = (props) => {
    return props.isMobile ? <JoinHivesMobile {...props} /> : <JoinHivesDesktop {...props} />;
};

export default JoinHives;
